export { default } from './category-tiles-grid';
